const WEB_TYPE = {
    ADULT: "tutorabc",
    CHILD: "tutorjr",
    ONEABC: "oneabc",
};

const WEB_BRAND =
    location.hostname.toLowerCase().indexOf("tutorjr") > -1
        ? WEB_TYPE.CHILD
        : WEB_TYPE.ADULT;

export const ENVIORNMENT = {
    DEV: "development",
    STAGE: "stage",
    PRE: "pre",
    PROD: "production",
};

export const configs = {
    [ENVIORNMENT.DEV]: {
        tutorabc: {
            apiUrl: "https://stage-programming.tutorabc.com",
            domainUrl: "http://activitys.tutorabc.com",
            webUrl: "http://activitys.tutorabc.com/activity/TrialClass",
            anotherWebUrl: "http://activitys.tutorjr.com/activity/JrTrialClass",
            webSiteUrl: "http://stage.tutorabc.com/site",
            forgetUrl:
                "http://stage.passport.tutorabc.com/customs/forget-password",
            memberCenterUrl: "http://stage.tutorabc.com/Center",
            memberClassUrl: "http://stage.tutorabc.com/Center/MySchedule ",
            contactUsUrl: "https://stage.tutorabc.com/site/contact-us",
            testUrl: "http://stage.tutorabc.com/Center/ExamV2",
            token: "TMDRDTEST",
            logInUrl: "https://stage-passport.tutorabc.com/api/url/login/1/tw",
            registerUrl:
                "http://stage-passport.tutorabc.com/api/url/regist/1/tw",
            logOutUrl: "http://stage-passport.tutorabc.com/api/logout/1",
            serviceUrl: "http://stage.tutorabc.com/site/terms?tab=2",
            privacyUrl: "http://stage.tutorabc.com/site/terms?tab=3",
            securityUrl: "http://stage.tutorabc.com/site/terms?tab=4",
            dittoUrl: "https://dittostage.tutorabc.com/integrate/v1",
            bookingUrl: "http://stage.tutorabc.com/Center/BookingV2/Booking",
            pricingUrl: "http://stage.tutorabc.com/site/pricing",
        },
        tutorjr: {
            apiUrl: "https://stage-programing.tutorjr.com",
            domainUrl: "http://activitys.tutorjr.com",
            webUrl: "http://activitys.tutorjr.com/activity/JrTrialClass",
            anotherWebUrl: "http://activitys.tutorabc.com/activity/TrialClass",
            webSiteUrl: "http://stage.tutorjr.com/aspx/mvc",
            forgetUrl:
                "http://stage.passport.tutorjr.com/customs/forget-password",
            memberCenterUrl: "http://stage.tutorjr.com/Center",
            memberClassUrl: "http://stage.tutorjr.com/Center/MySchedule",
            contactUsUrl: "https://stage.tutorjr.com/aspx/mvc/Home/ContactUs",
            testUrl: "http://stage.tutorjr.com/Center/ExamV2",
            token: "TMDRDTEST",
            logInUrl: "http://stage-passport.tutorjr.com/api/url/login/1/tw",
            registerUrl:
                "http://stage-passport.tutorjr.com/api/url/regist/1/tw",
            logOutUrl: "http://stage-passport.tutorjr.com/api/logout/1",
            serviceUrl: "https://stage.tutorjr.com/aspx/mvc/Terms?type=2",
            privacyUrl: "https://stage.tutorjr.com/aspx/mvc/Terms?type=3",
            securityUrl: "https://stage.tutorjr.com/aspx/mvc/Terms?type=4",
            dittoUrl: "https://dittostage.tutorabc.com/integrate/v1",
            bookingUrl: "http://stage.tutorjr.com/Center/BookingV2/Booking",
            pricingUrl: "http://stage.tutorabc.com/site/pricing",
        },
    },
    [ENVIORNMENT.STAGE]: {
        tutorabc: {
            apiUrl: "https://stage-programming.tutorabc.com",
            domainUrl: "http://activitys.tutorabc.com",
            webUrl: "http://activitys.tutorabc.com/activity/TrialClass",
            anotherWebUrl: "http://activitys.tutorjr.com/activity/JrTrialClass",
            webSiteUrl: "http://stage.tutorabc.com/site",
            forgetUrl:
                "http://stage.passport.tutorabc.com/customs/forget-password",
            memberCenterUrl: "http://stage.tutorabc.com/Center",
            memberClassUrl: "http://stage.tutorabc.com/Center/MySchedule",
            contactUsUrl: "https://stage.tutorabc.com/site/contact-us",
            testUrl: "http://stage.tutorabc.com/Center/ExamV2",
            token: "TMDRDTEST",
            logInUrl: "https://stage-passport.tutorabc.com/api/url/login/1/tw",
            registerUrl:
                "https://stage-passport.tutorabc.com/api/url/regist/1/tw",
            logOutUrl: "http://stage-passport.tutorabc.com/api/logout/1",
            serviceUrl: "http://stage.tutorabc.com/site/terms?tab=2",
            privacyUrl: "http://stage.tutorabc.com/site/terms?tab=3",
            securityUrl: "http://stage.tutorabc.com/site/terms?tab=4",
            dittoUrl: "https://dittostage.tutorabc.com/integrate/v1",
            bookingUrl: "http://stage.tutorabc.com/Center/BookingV2/Booking",
            pricingUrl: "http://stage.tutorabc.com/site/pricing",
        },
        tutorjr: {
            apiUrl: "https://stage-programing.tutorjr.com",
            domainUrl: "http://activitys.tutorjr.com",
            webUrl: "http://activitys.tutorjr.com/activity/JrTrialClass",
            anotherWebUrl: "http://activitys.tutorabc.com/activity/TrialClass",
            webSiteUrl: "http://stage.tutorjr.com/aspx/mvc",
            forgetUrl:
                "http://stage.passport.tutorjr.com/customs/forget-password",
            memberCenterUrl: "http://stage.tutorjr.com/Center",
            memberClassUrl: "http://stage.tutorjr.com/Center/MySchedule",
            contactUsUrl: "https://stage.tutorjr.com/aspx/mvc/Home/ContactUs",
            testUrl: "http://stage.tutorjr.com/Center/ExamV2",
            token: "TMDRDTEST",
            logInUrl: "https://stage-passport.tutorjr.com/api/url/login/1/tw",
            registerUrl:
                "https://stage-passport.tutorjr.com/api/url/regist/1/tw",
            logOutUrl: "http://stage-passport.tutorjr.com/api/logout/1",
            serviceUrl: "https://stage.tutorjr.com/aspx/mvc/Terms?type=2",
            privacyUrl: "https://stage.tutorjr.com/aspx/mvc/Terms?type=3",
            securityUrl: "https://stage.tutorjr.com/aspx/mvc/Terms?type=4",
            dittoUrl: "https://dittostage.tutorabc.com/integrate/v1",
            bookingUrl: "http://stage.tutorjr.com/Center/BookingV2/Booking",
            pricingUrl: "http://stage.tutorabc.com/site/pricing",
        },
    },
    [ENVIORNMENT.PRE]: {
        tutorabc: {
            apiUrl: "https://pre-programming.tutorabc.com",
            domainUrl: "https://activityp.tutorabc.com",
            webUrl: "https://activityp.tutorabc.com/TrialClass",
            anotherWebUrl: "https://activityp.tutorjr.com/JrTrialClass",
            webSiteUrl: "https://wwwp.tutorabc.com/site",
            forgetUrl:
                "https://pre-passport.tutorabc.com/customs/forget-password",
            memberCenterUrl: "https://wwwp.tutorabc.com/Center",
            memberClassUrl: "https://wwwp.tutorabc.com/Center/MySchedule",
            contactUsUrl: "https://wwwp.tutorabc.com/site/contact-us",
            testUrl: "https://wwwp.tutorabc.com/Center/ExamV2",
            token: "3c937d33e3c814fbc8cd35dc5fa87388d2e93b15",
            logInUrl: "https://pre-passport.tutorabc.com/api/url/login/1/tw",
            registerUrl:
                "https://pre-passport.tutorabc.com/api/url/regist/1/tw",
            logOutUrl: "https://pre-passport.tutorabc.com/api/logout/1",
            serviceUrl: "https://wwwp.tutorabc.com/site/terms?tab=2",
            privacyUrl: "https://wwwp.tutorabc.com/site/terms?tab=3",
            securityUrl: "https://wwwp.tutorabc.com/site/terms?tab=4",
            dittoUrl: "https://ditto-apip.tutorabc.com/integrate/v1",
            bookingUrl: "https://wwwp.tutorabc.com/Center/BookingV2/Booking",
            pricingUrl: "http://wwwp.tutorabc.com/site/pricing",
        },
        tutorjr: {
            apiUrl: "https://pre-programming.tutorjr.com",
            domainUrl: "https://activityp.tutorjr.com",
            webUrl: "https://activityp.tutorjr.com/activity/JrTrialClass",
            anotherWebUrl: "https://activityp.tutorabc.com/activity/TrialClass",
            webSiteUrl: "https://wwwp.tutorjr.com/aspx/mvc",
            forgetUrl:
                "https://pre-passport.tutorjr.com/customs/forget-password",
            memberCenterUrl: "https://wwwp.tutorjr.com/Center",
            memberClassUrl: "https://wwwp.tutorjr.com/Center/MySchedule",
            contactUsUrl: "https://wwwp.tutorjr.com/aspx/mvc/Home/ContactUs",
            testUrl: "https://wwwp.tutorjr.com/Center/ExamV2",
            token: "3c937d33e3c814fbc8cd35dc5fa87388d2e93b15",
            logInUrl: "https://pre-passport.tutorjr.com/api/url/login/1/tw",
            registerUrl: "https://pre-passport.tutorjr.com/api/url/regist/1/tw",
            logOutUrl: "https://pre-passport.tutorjr.com/api/logout/1",
            serviceUrl: "https://wwwp.tutorjr.com/aspx/mvc/Terms?type=2",
            privacyUrl: "https://wwwp.tutorjr.com/aspx/mvc/Terms?type=3",
            securityUrl: "https://wwwp.tutorjr.com/aspx/mvc/Terms?type=4",
            dittoUrl: "https://ditto-apip.tutorabc.com/integrate/v1",
            bookingUrl: "https://wwwp.tutorjr.com/Center/BookingV2/Booking",
            pricingUrl: "http://wwwp.tutorabc.com/site/pricing",
        },
    },
    [ENVIORNMENT.PROD]: {
        tutorabc: {
            apiUrl: "https://programming.tutorabc.com",
            domainUrl: "https://activity.tutorabc.com",
            webUrl: "https://activity.tutorabc.com/TrialClass",
            anotherWebUrl: "https://activity.tutorjr.com/JrTrialClass",
            webSiteUrl: "https://www.tutorabc.com/site",
            forgetUrl: "https://passport.tutorabc.com/customs/forget-password",
            memberCenterUrl: "https://www.tutorabc.com/Center",
            memberClassUrl: "https://www.tutorabc.com/Center/MySchedule",
            contactUsUrl: "https://www.tutorabc.com/site/contact-us",
            testUrl: "https://www.tutorabc.com/Center/ExamV2",
            token: "3c937d33e3c814fbc8cd35dc5fa87388d2e93b15",
            logInUrl: "https://passport.tutorabc.com/api/url/login/1/tw",
            registerUrl: "https://passport.tutorabc.com/api/url/regist/1/tw",
            logOutUrl: "https://passport.tutorabc.com/api/logout/1",
            serviceUrl: "https://www.tutorabc.com/site/terms?tab=2",
            privacyUrl: "https://www.tutorabc.com/site/terms?tab=3",
            securityUrl: "https://www.tutorabc.com/site/terms?tab=4",
            dittoUrl: "https://ditto-api.tutorabc.com/integrate/v1",
            bookingUrl: "https://www.tutorabc.com/Center/BookingV2/Booking",
            pricingUrl: "http://www.tutorabc.com/site/pricing",
        },
        tutorjr: {
            apiUrl: "https://programming.tutorjr.com",
            domainUrl: "https://activity.tutorjr.com",
            webUrl: "https://activity.tutorjr.com/JrTrialClass",
            anotherWebUrl: "https://activity.tutorabc.com/TrialClass",
            webSiteUrl: "https://www.tutorjr.com/aspx/mvc",
            forgetUrl: "https://passport.tutorjr.com/customs/forget-password",
            memberCenterUrl: "https://www.tutorjr.com/Center",
            memberClassUrl: "https://www.tutorjr.com/Center/MySchedule",
            contactUsUrl: "https://www.tutorjr.com/aspx/mvc/Home/ContactUs",
            testUrl: "https://www.tutorjr.com/Center/ExamV2",
            token: "3c937d33e3c814fbc8cd35dc5fa87388d2e93b15",
            logInUrl: "https://passport.tutorjr.com/api/url/login/1/tw",
            registerUrl: "https://passport.tutorjr.com/api/url/regist/1/tw",
            logOutUrl: "https://passport.tutorjr.com/api/logout/1",
            serviceUrl: "https://www.tutorjr.com/aspx/mvc/Terms?type=2",
            privacyUrl: "https://www.tutorjr.com/aspx/mvc/Terms?type=3",
            securityUrl: "https://www.tutorjr.com/aspx/mvc/Terms?type=4",
            dittoUrl: "https://ditto-api.tutorabc.com/integrate/v1",
            bookingUrl: "https://www.tutorjr.com/Center/BookingV2/Booking",
            pricingUrl: "http://www.tutorabc.com/site/pricing",
        },
    },
};

export const envConfigs = configs[process.env.NODE_ENV][WEB_BRAND];
